// Vendor Libs
import React, {useState} from 'react';
import PropTypes from 'prop-types';

// Sortable Libs
import {SortableContainer, SortableElement, SortableHandle} from 'react-sortable-hoc';
import arrayMove from 'array-move';

// Material UI
import {Paper} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ReorderIcon from '@material-ui/icons/Reorder';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles(() => ({
  paperTop: {
    width: 568,
    boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
    marginTop: 15,
  },
  paperHeader: {
    width: 568,
    height: 48,
    background: '#e6e6e6',
    boxShadow: 'none',
    marginTop: 16,
    borderRadius: 0,
  },
  paperTopHeader: {
    fontSize: '1.25rem',
    fontWeight: 500,
    lineHeight: 1.6,
    letterSpacing: '0.0075em',
    paddingTop: 17,
    paddingLeft: 24,
  },
  headerText: {
    color: '#424242',
    height: 48,
    padding: '5px 7px',
    fontSize: '0.9375rem',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    paddingLeft: 59,
    paddingTop: 13,
  },
  paperRow: {
    width: 568,
    height: 49,
    border: '0.5px solid #e0e0e0',
    zIndex: 10000,
  },
  paperText: {
    color: '#212121',
    padding: '5px 7px',
    fontSize: '0.8125rem',
    wordWrap: 'break-word',
    whiteSpace: 'wrap',
    textOverflow: 'wrap',
  },
  dragHandle: {
    cursor: 'move',
    color: '#777777',
    marginTop: 14,
    fontSize: '1.25rem',
  },
  paperRowStart: {
    background: 'white',
  },
  paperRowEnd: {
    background: '#f4f4f4',
    paddingTop: 12,
  },
  orderIcon: {
    color: '#777777',
  },
}));

const DragHandle = SortableHandle(() => {
  const classes = useStyles();
  return <ReorderIcon className={classes.dragHandle} />;
});

const separator = ':::';
const SortableItem = SortableElement(({value}) => {
  const classes = useStyles();
  const values = value.split(separator);
  const value1 = values.length ? values[0] : '';
  const value2 = values.length > 1 ? values[1] : '';
  return (
    <Grid className={classes.paperRow} container={true} direction="row">
      <Grid align="center" className={classes.paperRowStart} item={true} xs={1}>
        <DragHandle />
      </Grid>
      <Grid className={classes.paperRowEnd} item={true} xs={2}>
        <span className={classes.paperText}>{value1}</span>
      </Grid>
      <Grid className={classes.paperRowEnd} item={true} xs={9}>
        <span className={classes.paperText}>{value2}</span>
      </Grid>
    </Grid>
  );
});

const SortableContainerMain = SortableContainer(({children}) => <div>{children}</div>);

const SortableComponent = props => {
  const classes = useStyles();
  const {data, writeReorderedAssets} = props;
  const dataParsed = data.length
    ? data.map(d => ({
        displayData: `${d.asset.guid}${separator}${d.asset.name}`,
        dataObj: d,
      }))
    : [];
  const [items, setItems] = useState(dataParsed);
  const onSortEnd = ({oldIndex, newIndex}) => {
    const newArray = arrayMove(items, oldIndex, newIndex);
    const reOrdered = newArray.map(d => d.dataObj);
    setItems(newArray);
    writeReorderedAssets(reOrdered);
  };

  return (
    <div>
      <Paper className={classes.paperTop}>
        <Typography className={classes.paperTopHeader} component="div">
          Assets
        </Typography>
        <Paper className={classes.paperHeader}>
          <Typography className={classes.headerText} component="div">
            Echostar ID&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Name
          </Typography>
        </Paper>

        <SortableContainerMain useDragHandle={false} onSortEnd={onSortEnd}>
          {items.map((value, index) => (
            <SortableItem index={index} key={`item-${value.displayData}`} value={value.displayData} />
          ))}
        </SortableContainerMain>
      </Paper>
    </div>
  );
};

SortableComponent.propTypes = {
  data: PropTypes.array,
  writeReorderedAssets: PropTypes.func,
};

export default SortableComponent;
